<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken } from "@/util/auth";
import { getNoticeNum } from "@/api/health/manage";

export default {
  name: "App",
  data() {
    return {
      timer: null,
      page: {
        pageSize: 100,
        currentPage: 1,
      },
    };
  },
  watch: {},
  created() {
    this.getNoticeNum();
    if (this.timer == null) {
      this.startTimer();
    }
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {},
  methods: {
    startTimer() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(this.myTask, 30000);
    },

    myTask() {
      const token = getToken();
      const channel = window.localStorage.getItem("channel");
      if (token && channel) {
        this.getNoticeNum();
      }
    },

    getNoticeNum() {
      const params = {
        channel: window.localStorage.getItem("channel"),
      };

      getNoticeNum(this.page.currentPage, this.page.pageSize, params).then((res) => {
        const data = res.data;
        console.log("res", data);
        if (data) {
          this.$store.commit("NEW_USER", data.newUserCount);
          this.$store.commit("NEW_ALARM", data.newAlarmCount);
          this.$store.commit("WORN", data.warnCount);
          this.$store.commit("NEW_CONSULT", data.newConsultCount);
        }
      });
    },
  },
};
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
